import { createSelector } from '@ngrx/store';
import { appSettingsState } from '../root';

export const getAppSettingsTags = createSelector(appSettingsState, (appSettings) => appSettings?.apiSettings?.data?.TagSettings || null);
